import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["counter"]

  connect() {
    this.counters = this.counterTargets.map((element) => ({
      element,
      value: Number(element.dataset.value),
      finalText: element.textContent
    })).filter(({ element, value }) => element.dataset.value.trim() !== "" && Number.isFinite(value))

    if (document.documentElement.hasAttribute("data-turbolinks-preview") ||
        window.matchMedia("(prefers-reduced-motion: reduce)").matches ||
        typeof window.requestAnimationFrame !== "function" || this.counters.length === 0) return

    this.startedAt = null
    this.counters.forEach(({ element }) => { element.textContent = "0" })
    this.frame = window.requestAnimationFrame((timestamp) => this.animate(timestamp))
  }

  animate(timestamp) {
    if (this.startedAt === null) this.startedAt = timestamp
    const progress = Math.min((timestamp - this.startedAt) / 2500, 1)
    const easedProgress = 1 - Math.pow(1 - progress, 3)

    if (progress === 1) {
      this.finish()
      return
    }

    this.counters.forEach(({ element, value }) => {
      element.textContent = Math.round(value * easedProgress).toLocaleString("en-US")
    })
    this.frame = window.requestAnimationFrame((nextTimestamp) => this.animate(nextTimestamp))
  }

  finish() {
    if (this.frame != null) window.cancelAnimationFrame(this.frame)
    this.frame = null
    const counters = this.counters || []
    counters.forEach(({ element, finalText }) => { element.textContent = finalText })
  }

  disconnect() {
    this.finish()
  }
}
